var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { staticClass: "background" },
    [
      _c(
        "v-col",
        { attrs: { cols: "9" } },
        [
          _c(
            "custom-chart-renderer",
            [
              _c("bar-chart", {
                attrs: {
                  chartData: _vm.chartDataMonth,
                  options: _vm.optionsMonth,
                  autoRerender: false,
                  displayed: _vm.displayed
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { cols: "3" } },
        [
          _c(
            "custom-chart-renderer",
            [
              _c("bar-chart", {
                attrs: {
                  chartData: _vm.chartDataAverage,
                  options: _vm.optionsAverage,
                  autoRerender: false,
                  displayed: _vm.displayed
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }